import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { useTranslation, Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppContext from 'context/Context';
import { forgetPassword } from 'y4/Falcon';
import { getQuery } from 'y4/Utils';

const ForgetPasswordForm = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const user = getQuery(location.search, 'user');
  const {
    config: { team, corp }
  } = useContext(AppContext);
  // State
  const [email, setEmail] = useState(user || '');

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    if (email) {
      forgetPassword(team, corp, null, email, t, navigate);
    }
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={t('Email address')}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email}>
          <Trans ns="auth">Send reset link</Trans>
        </Button>
      </Form.Group>
      <Link
        className="fs--1 text-600"
        to={`/${corp}/authentication/card/login`}
      >
        <FontAwesomeIcon icon={['fas', 'arrow-left']} />{' '}
        <Trans ns="auth">Go back and try login again</Trans>
      </Link>
    </Form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
